import { StyleSheet } from 'react-native';

import colors from '../Themes/Colors';

const TIP_SIZE = 21;
const elevation = 7;
export const POINTER_SIZE = 45;

export default StyleSheet.create({
  container: top => ({
    left: 0,
    right: 0,
    position: 'absolute',
    top,
    shadowColor: colors.blackRGBA(0.4),
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
  content: {
    alignSelf: 'stretch',
    paddingHorizontal: 18,
    marginHorizontal: 16.5,
    borderRadius: 6.3,
    backgroundColor: colors.ocean,
    paddingTop: 17,
    paddingBottom: 23,
    elevation,
  },
  text: { color: colors.white, fontSize: 16.7, lineHeight: 18 },

  titleText: {
    fontWeight: 'bold',
  },
  titleContainer: { flexDirection: 'row', justifyContent: 'space-between' },
  contentContainer: { marginEnd: 16, flexShrink: 1 },

  contentText: {
    marginTop: 25,
    marginBottom: 18,
  },
  indicator: hPosition => ({
    marginStart: hPosition,
    alignItems: 'center',
    width: POINTER_SIZE,
    elevation,
  }),
  indicatorTip: isTop => ({
    width: TIP_SIZE,
    height: TIP_SIZE,
    transform: [{ rotateZ: '45deg' }],
    backgroundColor: colors.ocean,
    ...(isTop ? { top: -TIP_SIZE / 2 } : { bottom: -TIP_SIZE / 2 }),
  }),
  nextButton: {
    height: 33.4,
    borderWidth: 0,
    backgroundColor: colors.white,
  },
  nextButtonText: {
    fontWeight: 'bold',
    fontSize: 16.7,
    color: colors.dark_grey,
  },
});
